<template>
  <div class="PageSubscribe">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8">
          <div class="text-h5 font-weight-bold mb-1 text-center">Escolha seu plano</div>
          <div class="body-1 grey--text text-center mb-6">
            Acompanhe seus pacientes com mais profundidade e sem limites.
          </div>

          <v-row justify="center">
            <!-- Plano Gratuito -->
            <v-col cols="12" sm="6">
              <v-card outlined class="pa-4 fill-height">
                <v-card-title class="text-h6">Starter</v-card-title>
                <v-card-subtitle class="mb-2">Gratuito</v-card-subtitle>
                <v-divider class="mb-4" />
                <v-list dense>
                  <v-list-item v-for="item in starterFeatures" :key="item">
                    <v-list-item-icon>
                      <v-icon small color="grey">mdi-check</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-2">{{ item }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-card-actions class="mt-4">
                  <v-btn block outlined disabled>Plano atual</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>

            <!-- Plano Pro -->
            <v-col cols="12" sm="6">
              <v-card outlined class="pa-4 fill-height" color="primary" dark>
                <v-card-title class="text-h6">Pro</v-card-title>
                <v-card-subtitle class="mb-2">{{ planPrice }}<span class="caption">/mês</span></v-card-subtitle>
                <v-divider class="mb-4" />
                <v-list dense>
                  <v-list-item v-for="item in proFeatures" :key="item">
                    <v-list-item-icon>
                      <v-icon small>mdi-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-2">{{ item }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-card-actions class="mt-4">
                  <v-btn block color="white" light :loading="loading" @click="assinar">
                    Assinar Plano Pro
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <div class="text-center mt-4">
            <router-link to="/patients" class="body-2">Voltar para Meus Pacientes</router-link>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { SubscriptionService } from '../../lib/spasms-control'
import { getToken } from '../../utils'
import store from '../../store'

export default {
  name: 'PageSubscribe',
  data () {
    return {
      loading: false,
      planPrice: process.env.VUE_APP_PRO_PLAN_PRICE || 'R$ 29,90',
      starterFeatures: [
        'Até 5 pacientes ativos',
        'Lista de crises (data, hora, tipo)',
        'Frequência simples por semana/mês',
        'Histórico dos últimos 30 dias',
      ],
      proFeatures: [
        'Pacientes ilimitados',
        'Mapa de calor por hora do dia',
        'Distribuição por período do dia',
        'Evolução por tipo de espasmo',
        'Histórico completo sem limite de data',
        'Exportação de relatório em PDF',
        'Alertas de aumento de frequência',
      ],
    }
  },
  methods: {
    async assinar () {
      this.loading = true
      try {
        const service = new SubscriptionService(getToken())
        const data = await service.createCheckout()
        window.location.href = data.checkout_url
      } catch (err) {
        console.error(err)
        store.setSnackBarMessageAction('Erro ao iniciar checkout. Tente novamente.')
        store.setShowSnackBarAction(true)
        this.loading = false
      }
    }
  }
}
</script>
